// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"9872fee4","341":"b4cdd0dc","535":"c681a158"}[chunkId] + ".chunk.js";
};